import { render, staticRenderFns } from "./AssignDriverUnit.vue?vue&type=template&id=4b6b0b54&"
import script from "./AssignDriverUnit.vue?vue&type=script&lang=js&"
export * from "./AssignDriverUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports